module.exports = __webpack_public_path__ + "img/large6.b215c1a1.jpg";